export default {
  message: 'Message',
  active: 'Active',
  inactive: 'Inactive',
  isTyping: 'is typing',
  people: 'people',
  groups: 'groups',
  lastLogin: 'last login',
  read: 'read',
  am: 'AM',
  pm: 'PM',
  connecting: 'Connecting',
  cannotConnect: 'We can\'t connect to server',
  retry: 'Retry',
  typeAMessage: 'Type a message',
  sending: 'Sending...'
}
